import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../core/auth/services/auth.service';
import { Observable, of } from 'rxjs';
import { Client } from '../interfaces/client.interface';
import { Module } from '../../features/dashboard/interfaces/dashboard.interface';
import { Paginated } from '../interfaces/pagination.interface';

@Injectable({ providedIn: 'root' })
export class ClientService {
  private readonly STORAGE_KEY = 'current_client_data';
  private readonly API_URL = `${environment.moduloApiUrl}/api/clientes`.trim();
  private readonly authService = inject(AuthService);

  constructor(private http: HttpClient) {}

  setDadosCliente(): Observable<Client | null> {
    if (!this.authService.isAuthenticated) return of(null);

    const cached = this.getDadosCliente();
    if (cached) return of(cached);

    return this.http.get<Paginated<Client[]>>(this.API_URL).pipe(
      map(response => {
        if (response?.items?.length > 0) {
          const clientData = response.items[0];
          
          const current = localStorage.getItem(this.STORAGE_KEY);

          if (JSON.stringify(clientData) !== current) 
            localStorage.setItem(this.STORAGE_KEY, JSON.stringify(clientData));
          
          return clientData;
        }
        return null;
      })
    );
  }

  getDadosCliente(): Client | null {
    const data: string | null = localStorage.getItem(this.STORAGE_KEY);
    return data ? JSON.parse(data) : null;
  }

  getClienteId(): string | null {
    const data = this.getDadosCliente();
    return data ? data.id : null;
  }

  clearData() {
    localStorage.removeItem(this.STORAGE_KEY);
  }

  getClientSystems(): Observable<Module[]> {
    return this.http.get<Module[]>(`${this.API_URL}/${this.getClienteId()}/sistemas`);
  }
}